import React from 'react';
import { Navigate } from 'react-router-dom';

import WeatherLayout from 'components/Layout/Meteorology/Weather';
import MeteorologyProtectedWrapper from 'components/RouteWrappers/Meteorology/Protected';
import oscillationsRouter from './OscillationsRouter';
import seasonalForecastRouter from './SeasonalForecastRouter';
import comparatorRouter from './ComparatorRouter';
import similarityRouter from './SimilarityRouter';

const weatherRouter = {
  path: 'weather',
  element: <MeteorologyProtectedWrapper />,
  children: [
    {
      path: '',
      element: <WeatherLayout />,
      children: [
        { index: true, element: <Navigate to="/meteorology/weather/oscillations/" replace /> },
        oscillationsRouter,
        seasonalForecastRouter,
        comparatorRouter,
        similarityRouter,
      ],
    },
  ],
};

export default weatherRouter;
